var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsGiadinh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0984 26.8512C15.0984 24.4556 17.0404 22.5137 19.4359 22.5137H20.5635C22.959 22.5137 24.901 24.4556 24.901 26.8512V29.1718C24.901 29.4712 24.6582 29.714 24.3588 29.714H15.6406C15.3411 29.714 15.0984 29.4712 15.0984 29.1718V26.8512Z",
    fill: "url(#paint0_radial_5230_24439)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6406 18.3302C22.6406 19.7887 21.4583 20.971 19.9999 20.971C18.5414 20.971 17.3591 19.7887 17.3591 18.3302C17.3591 16.8718 18.5414 15.6895 19.9999 15.6895C21.4583 15.6895 22.6406 16.8718 22.6406 18.3302Z",
    fill: "url(#paint1_radial_5230_24439)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7577 17.5175C15.1155 17.9641 14.3352 18.2259 13.4938 18.2259C11.3013 18.2259 9.52389 16.4485 9.52389 14.256C9.52389 12.0635 11.3013 10.2861 13.4938 10.2861C15.6863 10.2861 17.4637 12.0635 17.4637 14.256C17.4637 14.4645 17.4476 14.6693 17.4166 14.8691C16.5698 15.5022 15.9631 16.4388 15.7577 17.5175ZM15.7492 19.097C15.0852 19.4714 14.3151 19.6856 13.4938 19.6856C12.2144 19.6856 11.0591 19.1658 10.2362 18.3303C7.92236 19.265 6.29395 21.4949 6.29395 24.097V27.4333C6.29395 27.8638 6.65053 28.2128 7.0904 28.2128H13.2721V26.925C13.2721 24.4337 14.8023 22.2997 16.9741 21.4117C16.3492 20.798 15.9102 19.9957 15.7492 19.097ZM26.7279 28.2128H32.9096C33.3495 28.2128 33.7061 27.8638 33.7061 27.4333V24.097C33.7061 21.4949 32.0777 19.265 29.7638 18.3303C28.941 19.1658 27.7857 19.6856 26.5063 19.6856C25.685 19.6856 24.9148 19.4714 24.2509 19.0969C24.0898 19.9957 23.6508 20.798 23.0259 21.4117C25.1977 22.2997 26.7279 24.4336 26.7279 26.925V28.2128ZM24.2424 17.5175C24.8845 17.9641 25.6648 18.2259 26.5063 18.2259C28.6988 18.2259 30.4762 16.4485 30.4762 14.256C30.4762 12.0635 28.6988 10.2861 26.5063 10.2861C24.3138 10.2861 22.5364 12.0635 22.5364 14.256C22.5364 14.4645 22.5525 14.6693 22.5835 14.8692C23.4302 15.5022 24.0369 16.4388 24.2424 17.5175Z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#paint2_radial_5230_24439)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5230_24439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.7962 31.8165) rotate(-90) scale(11.0804 45.029)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_5230_24439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.429 22.5132) rotate(-90) scale(8.1276 24.2611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5230_24439",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.2273 33.4474) rotate(-90) scale(27.5869 125.92)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#153C75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsGiadinh);
export default __webpack_public_path__ + "static/media/BS_giadinh.246529ee7bd45095af32d3e6e68e3bea.svg";
export { ForwardRef as ReactComponent };